export const hotKeyWords = [
  {
    url: 'http://souke.xdf.cn/Category/0-414-36;37-0.html?v=5&adpl=XDF_zhongxueN_hotword_1&adct=高考英语',
    title: '高考英语'
  },
  {
    url: 'http://souke.xdf.cn/Category/0-414-36;38-0.html?v=5&adpl=XDF_zhongxueN_hotword_2&adct=高考数学',
    title: '高考数学'
  },
  {
    url: 'http://souke.xdf.cn/Category/0-414-36;39-0.html?v=5&adpl=XDF_zhongxueN_hotword_3&adct=高考语文',
    title: '高考语文'
  },
  {
    url: 'http://souke.xdf.cn/Category/0-414-36;53-0.html?v=5&adpl=XDF_zhongxueN_hotword_4&adct=高考全日制',
    title: '高考全日制'
  },
  {
    url: 'http://souke.xdf.cn/Category/0-414-33;37-0.html?v=5&adpl=XDF_zhongxueN_hotword_5&adct=中考英语',
    title: '中考英语'
  },
  {
    url: 'http://souke.xdf.cn/Category/0-414-33;38-0.html?v=5&adpl=XDF_zhongxueN_hotword_6&adct=中考数学',
    title: '中考数学'
  },
  {
    url: 'http://souke.xdf.cn/Category/0-414-34-0.html?v=5&adpl=XDF_zhongxueN_hotword_6&adct=中考数学',
    title: '高一'
  },
  {
    url: 'http://souke.xdf.cn/Category/0-414-30-0.html?v=5&adpl=XDF_zhongxueN_hotword_8&adct=初一',
    title: '初一'
  }
]



// WEBPACK FOOTER //
// ./src/api/js/middleschool/hotkeywords.js